import { StrictMode } from "react";
import { ConvexProvider } from "convex/react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { convex } from "./data/convex-client";
import { SessionProvider } from "./data/use-session";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("index.html lost its #root");
createRoot(rootElement).render(
  <StrictMode>
    <ConvexProvider client={convex}>
      <SessionProvider>
        <App />
      </SessionProvider>
    </ConvexProvider>
  </StrictMode>,
);
